export function formatCreditCardNumber(number: string) {
	const digitsOnly = number.replace(/\D/g, "");
	return digitsOnly.replace(/(\d{4})(?=\d)/g, "$1 ");
}
